import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
  getCustomerType,
  getProvince,
  getProductType,
  getProduct,
  getSourceProduct,
  getTreetype,
  checkaccess,
  getregister,
  getstatustail,
  checkDoWood,
  GetCompany,
  getOwnercustomer,
} from "../../services/wms";
import {
  getaim,
  getTruckType,
  getStore,
  getQueuetime,
  getTailDriven,
  getowner,
  getdestination,
  GetMasterSourceProduct,
} from "./../../services/wms/grabconcept";
import { saveRegister } from "./../../services/wms/register";
import ModalSearchCustomer from "./searchcustomer1";
import ConfirmSubmit from "./../common/confirmSubmit";
import { toast } from "react-toastify";
import FontAwesome from "react-fontawesome";
import BranchContext from "./../context/branch";
import Input from "./inputcustom3";
import InputCheck from "./../common/checkbox/input";
import Select from "./selectcustom1";
import DatePicker from "react-datepicker";
import moment from "moment";
import dlv from "dlv";
import SelectOption from "../common/selectoption";
import { ThreeCircles } from "react-loader-spinner";

const Registerhub = (props) => {
  const { currentBranch } = useContext(BranchContext);
  const history = useHistory();
  const [Id, setId] = useState(props.Id);
  const [currentPrev, setcurrentPrev] = useState("");
  const [ckdisable, setckdisable] = useState(false);
  const [disabled, setdisabled] = useState(false);
  const [onLoad, setonLoad] = useState(false);
  const [loading, setloading] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const [disableSave, setdisableSave] = useState(false);
  const [formData, setFormData] = useState({
    producttype: 0,
    productid: 0,
    customername: "",
  });
  const [askConfirm, setaskConfirm] = useState(false);
  const [customertypelist, setcustomerType] = useState([]);
  const [provincelist, setprovincelist] = useState([]);
  const [taillist, settaillist] = useState([]);
  const [dolist, setdolist] = useState([]);
  const [producttypelist, setproducttype] = useState([]);
  const [productlist, setproduct] = useState([]);
  const [aimlist, setaim] = useState([]);
  const [trucktypelist, settrucktype] = useState([]);
  const [storelist, setstore] = useState([]);
  const [privilege, seprivilege] = useState(false);
  const [soureproductlist, setsoureproduct] = useState([]);
  const [isOpenAlert, setisOpenAlert] = useState(false);
  const [messageError, setmessageError] = useState({});
  const [messageWarning, setmessageWarning] = useState("");
  const [startDate, setstartDate] = useState(new Date());
  const [timelist, settimelist] = useState([]);
  const [currentqueue, setcurrentqueue] = useState({ timeid: 0, time: 0 });
  // const [timeId, settimeId] = useState("");
  const [alldata, setalldata] = useState([]);
  const [destinationlist, setdestination] = useState([]);
  const [listowner, setlistowner] = useState([]);
  const [lissoureproduct, setlissoureproduct] = useState([]);
  const [treetypelist, settreetype] = useState([]);
  const [fsclist, setfsc] = useState([]);
  const [onSave, setonSave] = useState(false);
  const [statustail, setstatustail] = useState(false);
  // const [avgwood, setavgwood] = useState("0");
  const [comsource, setcomsource] = useState([]);
  const [comsourceid, setcomsourceid] = useState([]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (currentBranch._id === "") return;
  //   if (!onLoad) return;
  //   const loadData = async () => {
  //     const { data: result } = await getCustomerType(
  //       currentBranch && currentBranch._id
  //     );
  //     if (result.status === "success") {
  //       setcustomerType(result.data.list);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch, onLoad]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    setfsc([
      { _id: 1, name: "Non-FSC" },
      { _id: 2, name: "Controlled Material" },
      { _id: 3, name: "FSC 100%" },
    ]);
    // const loadData = async () => {
    //   const { data: result } = await getdatafsc();
    //   if (result.status === "success") {
    //     setfsc(result.data.list);
    //   }
    // };
    // loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!formData.productid) return;

    const loadData = async () => {
      if (
        currentBranch &&
        currentBranch._id === "501" &&
        parseInt(formData.producttype) === 5
      ) {
        const { data: result } = await GetCompany(
          currentBranch && currentBranch._id,
          formData.productid
        );
        if (result) {
          setcomsource(result);
        }
      } else if (
        (currentBranch && currentBranch._id === "503") ||
        currentBranch._id === "502"
      ) {
        const { data: result } = await GetCompany(
          currentBranch && currentBranch._id,
          formData.productid
        );
        if (result) {
          setcomsource(result);
          if (result && result.length > 0) {
            setcomsourceid(result[0]._id);
            // handelComIdChange(result[0]._id)
          }
        }
      } else {
        setcomsource([]);
      }
    };
    loadData();
  }, [currentBranch, formData.productid, formData.producttype]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getTailDriven(
        currentBranch && currentBranch._id
      );
      if (result) {
        settaillist(result);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    if (!formData.deliveryno) return;
    if (formData.deliveryno.length < 6) return;
    // if (formData.producttype === 2 ){
    const loadData = async () => {
      const { data: result } = await checkDoWood(
        formData.deliveryno,
        currentBranch && currentBranch._id
      );
      if (result) {
        setdolist(result);
        if (result.length) {
          setFormData({
            ...formData,
            producttype: result[0].typeid,
            productid: result[0].productid,
            customertype: result[0].CustomerType,
            treetypeid: result[0].woodtype,
            aimno: result[0].aimname,
            customer_id:
              result[0].customerid === 0
                ? formData.customer_id
                : result[0].customerid,
            customername:
              result[0].customerid === 0
                ? formData.customername
                : result[0].Customer_name,
            fscid: result[0].ControlledWood,
            drivenno: result[0].id,
          });
        }
      } else {
        // setdolist([]);
      }
    };

    loadData();
    // }
  }, [formData.deliveryno, currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await checkaccess(
        currentBranch && currentBranch._id
      );
      if (result) {
        seprivilege(result);
      }
    };
    loadData();
  }, [currentBranch]);

  const patternValidation = (val) => {
    return /\s/g.test(val);
  };
  let pvl = [];

  const handleInputChange = (inputKey, data, validate) => {
    const isValid = patternValidation(data);
    setFormData({
      ...formData,
      [inputKey]: data,
    });
    if (validate) {
      if (isValid) {
        setmessageError({
          ...messageError,
          [inputKey]: "Empty spaces are not allowed",
        });
        return;
      }
    }
    if (data) {
      setmessageError({ ...messageError, [inputKey]: "" });
      setmessageWarning("");
      setisOpenAlert(false);
    }
  };

  const handleChangStartDate = (event) => {
    setstartDate(event);
  };

  const handleSelectChange = (inputKey, data) => {
    if (!data) return;
    if (inputKey === "producttype") {
      if (!(data === 1 || data === 2)) {
        setFormData({
          ...formData,
          [inputKey]: JSON.parse(data),
          productid: 0,
          fscid: 0,
          treetypeid: "",
        });
      } else {
        setFormData({
          ...formData,
          [inputKey]: JSON.parse(data),
          productid: 0,
        });
      }
      if (JSON.parse(data) !== 0) {
        setmessageError({
          ...messageError,
          [inputKey]: "",
          producttype: false,
        });
      } else {
        setmessageError({ ...messageError, producttype: true });
      }
    } else {
      setFormData({
        ...formData,
        [inputKey]: data,
      });
      try {
        if (JSON.parse(data) !== 0) {
          setmessageError({ ...messageError, [inputKey]: "" });
        }
      } catch {
        setmessageError({ ...messageError, [inputKey]: "" });
      }
    }
  };
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getProvince(
        currentBranch && currentBranch._id
      );

      if (result) {
        setprovincelist(result);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;

    const loadData = async () => {
      const { data: result } = await GetMasterSourceProduct(
        currentBranch && currentBranch._id
      );
      if (result.length > 0) {
        setlissoureproduct(result);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;

    const loadData = async () => {
      const { data: result } = await getowner(
        currentBranch && currentBranch._id
      );
      if (result.length > 0) {
        setlistowner(result);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getCustomerType(
        currentBranch && currentBranch._id
      );
      if (result.status === "success") {
        setcustomerType(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getProductType(
        currentBranch && currentBranch._id
      );
      if (result && result.length > 0) {
        setproducttype(result);
      } else {
        setproducttype([]);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    if (!currentBranch._id) return;
    // if (!formData.producttype) return;
    const loadData = async () => {
      const { data: result } = await getProduct(
        currentBranch && currentBranch._id,
        formData.producttype
      );
      if (result) {
        setproduct(result);
      } else {
        setproduct([]);
      }
    };
    loadData();
  }, [formData.producttype, currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    const loadData = async () => {
      const { data: result } = await getTreetype(501);
      if (result.status === "success") {
        settreetype(result.data.list);

        if (result.data.list.length > 0) {
          setFormData({
            ...formData,
            treetypeid: result.data.list[0]._id,
          });
        }
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getaim(currentBranch && currentBranch._id);
      if (result) {
        setaim(result);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getTruckType(
        currentBranch && currentBranch._id
      );
      if (result) {
        settrucktype(result);
      }
    };
    loadData();
    // });
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getdestination(
        currentBranch && currentBranch._id
      );
      if (result.length > 0) {
        setdestination(result);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (!currentBranch._id) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getStore(
        currentBranch && currentBranch._id
      );
      if (result) {
        setstore(result);
      }
    };
    loadData();
  }, [currentBranch]);
  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;
    const loadData = async () => {
      const { data: result } = await getSourceProduct(
        currentBranch && currentBranch._id
      );
      if (result) {
        setsoureproduct(result);
      }
    };
    loadData();
  }, [currentBranch]);

  // useEffect(() => {
  //   if (!currentBranch) return;
  //   if (currentBranch._id === "") return;
  //   const loadData = async () => {
  //     const { data: result } = await getstatustail(
  //       currentBranch && currentBranch._id,"04"
  //     );

  //     if (result) {
  //       setstatustail(result);
  //     }
  //   };
  //   loadData();
  // }, [currentBranch,formData.storeno]);

  useEffect(() => {
    try {
      if (!formData.customer_id) return;
      if (!currentBranch) return;
      if (!formData.producttype) return;
      if (!formData.productid) return;
      if (!formData.firstdrivenno) return;
      if (!formData.firstdriven2) return;
      if (!onLoad && Id !== "new") return;
      if (currentBranch && currentBranch._id !== "501") return;
      const loadData = async () => {
        const { data: result } = await getQueuetime(
          moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
          currentBranch && currentBranch._id,
          formData.productid,
          formData.customer_id,
          formData.producttype,
          formData.producttype,
          formData.firstdrivenno + "-" + formData.firstdriven2,
          formData.producttype,
          Id === "new" ? 0 : Id
        );
        if (result) {
          settimelist(result);
          if (result.length > 0) {
            setcurrentqueue({ timeid: result[0]._id, time: result[0]._id });
          }
        }
      };
      loadData();
    } catch {
      settimelist([]);
    }
  }, [
    moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
    currentBranch,
    formData.customer_id,
    formData.productid,
    formData.firstdrivenno,
    formData.firstdriven2,
    formData.producttype,
    onLoad,
    Id,
  ]);

  useEffect(() => {
    try {
      if (!currentBranch) return;
      if (!formData.producttype) return;
      if (!formData.productid) return;
      if (!onLoad && Id !== "new") return;
      if (currentBranch && currentBranch._id === "501") return;
      const loadData = async () => {
        const { data: result } = await getQueuetime(
          moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
          currentBranch && currentBranch._id,
          formData.productid,
          formData.customer_id,
          formData.producttype,
          formData.producttype,
          formData.firstdrivenno + "-" + formData.firstdriven2,
          formData.producttype,
          Id === "new" ? 0 : Id
        );
        if (result) {
          settimelist(result);
          if (result.length > 0) {
            setcurrentqueue({ timeid: result[0]._id, time: result[0]._id });
          }
        }
      };
      loadData();
    } catch {
      settimelist([]);
    }
  }, [
    moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
    currentBranch,
    formData.productid,
    formData.producttype,
    onLoad,
    Id,
  ]);

  useEffect(() => {
    const loadRegister = async () => {
      try {
        if (currentBranch._id === "") return;
        if (!Id) return;

        if (Id === "new") {
          setalldata([]);
          setcurrentPrev(currentBranch._id);
          return;
        }
        if (currentPrev === "" || currentBranch._id === currentPrev) {
        } else {
          toast.error("กรุณาระบุรายการใหม่");
          setdisableSave(false);
          setalldata([]);

          const urlGoBack = "/registerlist/";
          setTimeout(history.replace(urlGoBack), 1000);
          return;
        }

        setloading(true);
        setcurrentPrev(currentBranch._id);
        const { data: result } = await getregister(Id, currentBranch._id);

        if (result) {
          result.filter((item) => item.AutoID === Id);
          setloading(false);
          setalldata(result);
        } else {
          toast.error(result.message);
          setloading(false);
        }
      } catch (ex) {
        toast.error(ex.message);
        setloading(false);
      }
    };

    loadRegister();
  }, [Id, currentBranch, currentPrev]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id === "") return;

    const getalldata = () => {
      setId(props.Id);
      if (alldata && alldata.length === 1) {
        setonLoad(true);
        const startdate = new Date(alldata[0].queue_date);
        setstartDate(startdate);
        var res = alldata[0].first_driven_no.split("-");
        var res1 = alldata[0].second_driven_no
          ? alldata[0].second_driven_no.split("-")
          : "";
        if (alldata[0].progress > 1) {
          setdisableSave(true);
          setdisabled(true);
        }
        setFormData({
          customertype: alldata[0].customerType_id,
          customer_id: alldata[0].supplier_id,
          customer_code: alldata[0].customer_code,
          producttype: alldata[0].type_id,
          productid: alldata[0].productid,
          customername: alldata[0].Customer_Name
            ? alldata[0].Customer_Name
            : alldata[0].customername,
          drivenname: alldata[0].Driver_Name
            ? alldata[0].Driver_Name
            : alldata[0].driven_name,
          drivenno: alldata[0].driven_no
            ? dlv(alldata[0], "driven_no", "")
            : alldata[0].driven_no,
          driventel: alldata[0].driver_tel,
          aimno: alldata[0].receive_aim,
          deliveryno: dlv(alldata[0], "DO", ""),
          trucktype: alldata[0].trucktype,
          firstdrivenno: res[0],
          firstdriven2: res.length > 1 ? res[1] : "",
          firstprovince: alldata[0].first_driven_prov,
          seconddriven: res1[0],
          seconddriven1: res1.length > 1 ? res1[1] : "",
          secondProvince: alldata[0].second_driven_prov
            ? dlv(alldata[0], "second_driven_prov", 0)
            : 0,
          timeid: alldata[0].queue_time,
          storeno: dlv(alldata[0], "store_id", 0),
          soureproduct: dlv(alldata[0], "SourceProduct", 0),
          remark: dlv(alldata[0], "remark", ""),
          time: dlv(alldata[0], "timeid", ""),
          comsourceid: dlv(alldata[0], "company_id", 0),

          Ownercustomer: dlv(alldata[0], "ownerid", 0),
          sourceweight: dlv(alldata[0], "source_weight", 0),
          Sourceid: dlv(alldata[0], "sourceproduct1", 0),
        });
      }
    };
    getalldata();
  }, [currentBranch, alldata]);

  useEffect(() => {
    const changeval = () => {
      if (customertypelist.length === 2) {
        handleSelectChange("customertype", customertypelist[1]._id);
        formData.customertype = customertypelist[1]._id;
      }
      if (producttypelist.length === 2) {
        handleSelectChange("producttype", producttypelist[1].Type_ID);
        formData.producttype = producttypelist[1].Type_ID;
      }
      if (aimlist.length === 2) {
        handleSelectChange("aimno", aimlist[1].aim_no);
        formData.aimno = aimlist[1].aim_no;
      }
    };
    if (Id === "new") {
      changeval();
    }
  }, [customertypelist, producttypelist, aimlist]);
  const Gotobackup = () => {
    setTimeout(history.goBack(), 1000);
  };
  const handleonSave = () => {
    if (!formData.time && timelist && timelist.length > 0) {
      setFormData({
        ...formData,
        time: currentqueue.timeid,
        timeid: currentqueue.timeid,
      });
    }

    if (!formData.customertype || formData.customertype === "00") {
      setmessageError({
        ...messageError,
        customertype: true,
      });
      return;
    } else if (!formData.customername) {
      setmessageError({
        ...messageError,
        customername: true,
      });
      return;
    } else if (!formData.customer_id) {
      setmessageError({
        ...messageError,
        customername: true,
      });
      return;
    } else if (
      !formData.drivenno &&
      ((currentBranch && parseInt(currentBranch._id) !== 510) ||
        (currentBranch && parseInt(currentBranch._id) > 519))
    ) {
      setmessageError({
        ...messageError,
        drivenno: true,
      });
      return;
    } else if (!formData.driventel) {
      setmessageError({
        ...messageError,
        driventel: true,
      });
      return;
    } else if (!formData.drivenname) {
      setmessageError({
        ...messageError,
        drivenname: true,
      });
      return;
    } else if (!formData.producttype || formData.producttype === 0) {
      setmessageError({
        ...messageError,
        producttype: true,
      });
      return;
    } else if (!formData.productid || formData.productid === 0) {
      setmessageError({
        ...messageError,
        productid: true,
      });
      return;
    } else if (!formData.aimno || formData.aimno === 0) {
      setmessageError({
        ...messageError,
        aimno: true,
      });
      return;
    } else if (!formData.trucktype || formData.trucktype === 0) {
      setmessageError({
        ...messageError,
        trucktype: true,
      });
      return;
    } else if (!formData.firstdrivenno) {
      setmessageError({
        ...messageError,
        firstdrivenno: true,
      });
      return;
    } else if (!formData.firstdriven2) {
      setmessageError({
        ...messageError,
        firstprovince: true,
      });
      return;
    } else if (!formData.firstprovince || formData.firstprovince === 0) {
      setmessageError({
        ...messageError,
        firstprovince: true,
      });
      return;
    } else if (!formData.time) {
      setmessageError({
        ...messageError,
        time: true,
      });
      return;
    } else if (
      !formData.storeno &&
      (formData.aimno === "01" || formData.aimno === "03")
    ) {
      setmessageError({
        ...messageError,
        storeno: true,
      });
      return;
    } else if (!formData.firstdriven2) {
      setmessageError({
        ...messageError,
        firstdriven2: "Empty spaces are not allowed",
      });

      return;
    } else if (!formData.driventel) {
      setmessageError({
        ...messageError,
        driventel: "Empty spaces are not allowed",
      });

      return;
    }

    if (
      currentBranch &&
      parseInt(currentBranch._id) === 501 &&
      formData.producttype === 2
    ) {
      if (!formData.treetypeid || parseInt(formData.treetypeid) === 0) {
        setmessageError({
          ...messageError,
          treetypeid: true,
        });
        return;
      } else if (formData.driventel.length < 9) {
        setmessageError({
          ...messageError,
          driventel: true,
        });
        return;
      }
      try {
        const telephone = parseInt(formData.driventel);
        if (formData.driventel.length < 9 || formData.driventel.length > 10) {
          setmessageError({
            ...messageError,
            driventel: true,
          });
          return;
        }
      } catch (e) {
        setmessageError({
          ...messageError,
          driventel: true,
        });
        return;
      }
    }

    if (
      currentBranch &&
      parseInt(currentBranch._id) > 519 &&
      formData.producttype === 2
    ) {
      if (formData.driventel.length < 9) {
        setmessageError({
          ...messageError,
          driventel: true,
        });
        return;
      }
      try {
        const telephone = parseInt(formData.driventel);
        if (formData.driventel.length < 9 || formData.driventel.length > 10) {
          setmessageError({
            ...messageError,
            driventel: true,
          });
          return;
        }
      } catch (e) {
        setmessageError({
          ...messageError,
          driventel: true,
        });
        return;
      }
    }
    setaskConfirm(true);

    // doSubmit();
  };
  const doSubmit = async () => {
    // console.log("formData", formData);
    try {
      const doc = {
        _id: Id === "new" ? 0 : Id,
        customer_id: formData.customer_id,
        customer_type: formData.customertype,
        driven_id: formData.drivenno,
        driven_name: formData.drivenname,
        driven_tel: dlv(formData, "driventel", ""),
        aim_no: formData.aimno,
        delivery_no: dlv(formData, "deliveryno", ""),
        branch_id: currentBranch && currentBranch._id,
        store_id: formData.storeno,
        truck_type: formData.trucktype,
        product_id: formData.productid,
        product_type: formData.producttype,
        trucktype: formData.trucktype,
        firstdriven_prov: formData.firstprovince,
        seconddriven_prov: dlv(formData, "secondProvince", 0),
        queue_date: moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        queue_time: formData.time ? formData.time : formData.timeid,
        timeid: formData.timeid,
        firstdriven_no: formData.firstdrivenno + "-" + formData.firstdriven2,
        seconddriven_no:
          dlv(formData, "seconddriven", "") +
          "-" +
          dlv(formData, "seconddriven1", ""),
        remark: dlv(formData, "remark", ""),
        Company2: formData.comsourceid,
        appcode: "react",
        WoodType_ID: dlv(formData, "treetypeid", "00"),
        Controlledwood: dlv(formData, "fscid", 0),
        detination: formData.destination,
        isnormal: ckdisable,
        AVGWood: formData.avgwood,
        ownerid: formData.Ownercustomer,
        source_weight: formData.sourceweight,
        sourceproduct: formData.Sourceid,
      };
      // console.log("doc",doc)
      setdisableSave(true);
      const { data: result } = await saveRegister(doc);

      if (result.status === "success") {
        setdisableSave(false);
        toast.success("บันทึกเสร็จเรียบร้อย");
        setonSave(false);
        const urlGoBack = "/registerlist/";
        setTimeout(history.replace(urlGoBack), 1000);
      } else {
        toast.error(result.message);
        setonSave(false);
        setdisableSave(false);
      }
    } catch (err) {
      toast.error("Error Try Catch");
      setonSave(false);
      setdisableSave(false);
    }
  };

  const onCancel = () => {
    setisOpen(false);
  };
  const onSelect = (event) => {
    setFormData({
      ...formData,
      customername: event.name,
      customer_id: event._id,
      customer_code: event.id,
    });
    setisOpen(false);
  };
  const handleonClick = () => {
    setisOpen(true);
  };
  const handleTextchange = () => {
    setckdisable(!ckdisable);
  };
  const handleConfirmSubmit = () => {
    setaskConfirm(false);
    doSubmit();
  };
  const handleCancleSubmit = () => {
    setaskConfirm(false);
  };
  if (!privilege) {
    return <></>;
  }

  if (loading) {
    return (
      <div className="container-fluid h-100">
        <div className="row h-100 p-4">
          <div className="col-12 d-flex justify-content-center align-items-center">
            <ThreeCircles
              visible={true}
              height="200"
              width="200"
              color="#0d6efd"
              ariaLabel="three-circles-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
          <div className="col-12 text-center fw-bold text-primary mt-3">
            กำลังโหลดข้อมูล...
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="container"
        style={{
          maxHeight: "100px",
          // Width: "100%",
          maxWidth: "1000px",
        }}
      >
        <ConfirmSubmit
          isOpen={askConfirm}
          onConfirm={handleConfirmSubmit}
          onCancel={handleCancleSubmit}
          message={"ท่านยืนยันที่จะบันทึกรายการใช่หรือไม่"}
          button1="OK"
          size={"lg"}
        />
        <ModalSearchCustomer
          isOpen={isOpen}
          header={"รายชื่อลูกค้า"}
          search={formData.customername}
          onCancel={onCancel}
          onSelect={onSelect}
        />

        <div className="row  ">
          <span className="text-primary fs-2 fw-bold text-center">
            <i className="bi bi-person-circle me-2 fs-4"></i>
            ลงทะเบียน เข้าโรงงาน
          </span>

          <div className="card m-1 shadow ">
            <span className="fs-5 text-primary fw-bold ">
              {" "}
              <i className="bi bi-person-check-fill me-1 "></i> ข้อมูลลูกค้า
            </span>
            <div className="row mx-2 mb-2">
              <div className="col-lg-3 col-sm-6 p-1">
                <Select
                  label={"ประเภทลูกค้า"}
                  disabled={disableSave || loading}
                  data={customertypelist}
                  value={formData.customertype}
                  name={"customertype"}
                  onChange={handleSelectChange}
                  error={messageError.customertype}
                />
              </div>
              <div className="col-lg-3 col-sm-6 p-1">
                <Input
                  disabled={true}
                  label={"รหัสลูกค้า"}
                  name="customername"
                  maxLength={100}
                  value={formData.customer_code}
                  onChange={handleSelectChange}
                  error={messageError.customer_code}
                />
              </div>

              <div className="col-lg-6 col-sm-6 p-1">
                <Input
                  disabled={disableSave || loading}
                  placeholder="ระบุชื่อ"
                  label={"ชื่อลูกค้า"}
                  name="customername"
                  maxLength={100}
                  value={formData.customername}
                  onChange={handleInputChange}
                  error={messageError.customername}
                  search="ค้นหา"
                  onClick={handleonClick}
                />
              </div>
              <div className="col-lg-3 col-sm-6 p-1">
                <Select
                  label={"เจ้าของสินค้า"}
                  disabled={disableSave || loading}
                  data={listowner}
                  value={formData.Ownercustomer}
                  name={"Ownercustomer"}
                  onChange={handleSelectChange}
                  error={messageError.Ownercustomer}
                />
              </div>
              <div className="col-lg-4 col-sm-6 p-1">
                <Input
                  disabled={disableSave || loading}
                  placeholder="ระบุชื่อ"
                  label={"ชื่อคนขับ"}
                  name="drivenname"
                  maxLength={100}
                  value={formData.drivenname}
                  onChange={handleInputChange}
                  error={messageError.drivenname}
                  search="ค้นหา"
                />
              </div>
              <div className="col-lg-4 col-sm-6 p-1">
                <Input
                  disabled={disableSave || loading}
                  placeholder="ระบุหมายเลขบัตร"
                  label={"เลขบัตร คนขับ"}
                  name="drivenno"
                  maxLength={100}
                  value={formData.drivenno}
                  onChange={handleInputChange}
                  error={messageError.drivenno}
                />
              </div>
              <div className="col-lg-4 col-sm-6 p-1">
                <Input
                  disabled={disableSave || loading}
                  placeholder="ระบุเบอร์โทร"
                  label={"เบอร์โทรคนขับ"}
                  name="driventel"
                  maxLength={100}
                  value={formData.driventel}
                  onChange={handleInputChange}
                  error={messageError.driventel}
                />
              </div>
            </div>
          </div>

          <div className="card m-1 shadow ">
            <span className="fs-5 text-primary fw-bold ">
              {" "}
              <i className="bi bi-card-list"></i> ข้อมูลสินค้า
            </span>

            <div className="row mx-2 mb-2">
              <div className="col-lg-4 col-sm-6 p-1">
                <Select
                  label={"ประเภทสินค้า"}
                  disabled={disableSave || loading}
                  data={producttypelist}
                  value={formData.producttype}
                  name={"producttype"}
                  onChange={handleSelectChange}
                  error={messageError.producttype}
                  textProperty="type_name"
                  valueProperty="Type_ID"
                />
              </div>
              <div className="col-lg-4 col-sm-6 p-1">
                <Select
                  label={"ชื่อสินค้า"}
                  disabled={disableSave || loading}
                  data={productlist}
                  value={formData.productid}
                  name={"productid"}
                  onChange={handleSelectChange}
                  error={messageError.productid}
                  textProperty="ProductName"
                  valueProperty="Product_ID"
                />
              </div>
              {(formData.producttype === 2 ||
                formData.producttype === 1 ||
                formData.producttype === 10) &&
                currentBranch &&
                parseInt(currentBranch._id) !== 510 && (
                  <div className="col-lg-4 col-sm-6 p-1">
                    <Select
                      label={"พันธุ์ไม้"}
                      disabled={disableSave || loading}
                      data={treetypelist}
                      value={formData.treetypeid}
                      name={"treetypeid"}
                      onChange={handleSelectChange}
                      error={messageError.treetypeid}
                    />
                  </div>
                )}
              <div className="col-lg-4 col-sm-6 p-1">
                <Select
                  label={"วัตถุประสงค์"}
                  disabled={disableSave || loading}
                  data={aimlist}
                  value={formData.aimno}
                  name={"aimno"}
                  onChange={handleSelectChange}
                  error={messageError.aimno}
                  textProperty="aim_name"
                  valueProperty="aim_no"
                />
              </div>
              <div className="col-lg-4 col-sm-6 p-1">
                <Input
                  disabled={disableSave || loading}
                  placeholder="ใบนำส่ง"
                  label={"ใบนำส่ง"}
                  name="deliveryno"
                  maxLength={100}
                  value={formData.deliveryno}
                  onChange={handleInputChange}
                  error={messageError.deliveryno}
                />
              </div>
              {parseInt(currentBranch._id) == 510 && (
                <div className="col-lg-4 col-sm-6 p-1">
                  <Select
                    label={"ต้นทางสินค้า"}
                    disabled={disableSave || loading}
                    data={lissoureproduct}
                    value={formData.Sourceid}
                    name={"Sourceid"}
                    onChange={handleSelectChange}
                    error={messageError.Sourceid}
                    textProperty="name"
                    valueProperty="_id"
                  />
                </div>
              )}
              <div className="col-lg-4 col-sm-6 p-1">
                <Input
                  type="number"
                  disabled={disableSave || loading}
                  placeholder="น้ำหนักต้นทาง"
                  label={"น้ำหนักต้นทาง"}
                  name="sourceweight"
                  maxLength={100}
                  cd
                  value={formData.sourceweight}
                  onChange={handleInputChange}
                  error={messageError.sourceweight}
                />
              </div>
              {(formData.producttype === 2 ||
                formData.producttype === 1 ||
                formData.producttype === 10) &&
                currentBranch &&
                parseInt(currentBranch._id) !== 510 && (
                  <div className="col-lg-4 col-sm-6 p-1">
                    <Input
                      disabled={disableSave || loading}
                      label={"อายุไม้ (วัน)"}
                      name="avgwood"
                      maxLength={3}
                      type="number"
                      value={formData.avgwood}
                      onChange={handleInputChange}
                      error={messageError.avgwood}
                    />
                  </div>
                )}
              {(formData.producttype === 2 ||
                formData.producttype === 1 ||
                formData.producttype === 10) &&
                currentBranch &&
                parseInt(currentBranch._id) !== 510 && (
                  <div className="col-lg-4 col-sm-6 p-1">
                    <Select
                      label={"ประเภท FSC"}
                      disabled={disableSave || loading}
                      data={fsclist}
                      value={formData.fscid}
                      name={"fscid"}
                      onChange={handleSelectChange}
                      error={messageError.fscid}
                    />
                  </div>
                )}
              {formData.producttype === 5 &&
                currentBranch &&
                parseInt(currentBranch._id) !== 510 && (
                  <div className="col-lg-4 col-sm-6 p-1">
                    <Select
                      label={"บริษัทที่ลงสินค้า"}
                      disabled={disableSave || loading}
                      data={comsource}
                      value={formData.comsourceid}
                      name={"comsourceid"}
                      onChange={handleSelectChange}
                      error={messageError.comsourceid}
                    />
                  </div>
                )}
            </div>
          </div>

          <div className="card m-1 shadow ">
            <span className="fs-5 text-primary fw-bold ">
              {" "}
              <i className="bi bi-truck me-1 "></i> ข้อมูลรถ
            </span>

            <div className="row mx-2 mb-2">
              <div className="col-lg-6 col-sm-6 p-1">
                <Select
                  label={"ประเภทรถ"}
                  disabled={disableSave || loading}
                  data={trucktypelist}
                  value={formData.trucktype}
                  name={"trucktype"}
                  onChange={handleSelectChange}
                  error={messageError.trucktype}
                  textProperty="truck_typename"
                  valueProperty="truck_typeid"
                />
              </div>
              <div className="col-lg-6 p-1"></div>
              <div className="col-lg-2 col-sm-4 p-1">
                <Input
                  disabled={disableSave || loading}
                  label={"ทะเบียนหัว"}
                  name="firstdrivenno"
                  maxLength={3}
                  value={formData.firstdrivenno}
                  onChange={handleInputChange}
                  error={messageError.firstdrivenno}
                />
              </div>
              <div className="col-lg-4 col-sm-4 p-1">
                <label htmlFor="exampleDataList" className="form-label m-0">
                  &nbsp;
                </label>
                <Input
                  disabled={disableSave || loading}
                  label={""}
                  name="firstdriven2"
                  maxLength={4}
                  value={formData.firstdriven2}
                  onChange={handleInputChange}
                  error={messageError.firstdriven2}
                />
              </div>
              <div className="col-lg-6 col-sm-4 p-1">
                {/* <Select
                label={"จังหวัด"}
                disabled={disableSave || loading}
                data={provincelist}
                value={formData.firstprovince}
                name={"firstprovince"}
                onChange={handleSelectChange}
                error={messageError.firstprovince}
                textProperty="ProvinceName"
                valueProperty="ProvinceID"
              />
              {console.log(formData.firstprovince)} */}

                {provincelist &&
                  provincelist.length > 0 &&
                  provincelist.map((item) => {
                    pvl = [
                      ...pvl,
                      { value: item.ProvinceID, label: item.ProvinceName },
                    ];
                  })}
                <SelectOption
                  label={"จังหวัด"}
                  disabled={disableSave || loading}
                  data={pvl}
                  name={"firstprovince"}
                  onChange={(data) => {
                    handleSelectChange("firstprovince", data);
                  }}
                  value={pvl.find(
                    (item) => item.value === parseInt(formData.firstprovince)
                  )}
                  error={messageError.firstprovince}
                  isSearchable={true}
                />
              </div>
              <div className="col-lg-2 col-sm-4 p-1">
                <Input
                  disabled={disableSave || loading}
                  label={"ทะเบียนหาง"}
                  name="seconddriven"
                  maxLength={3}
                  value={formData.seconddriven}
                  onChange={handleInputChange}
                  error={messageError.seconddriven}
                />
              </div>
              <div className="col-lg-4 col-sm-4 p-1">
                <label htmlFor="seconddriven1" className="form-label m-0">
                  &nbsp;
                </label>
                <Input
                  disabled={disableSave || loading}
                  label={""}
                  name="seconddriven1"
                  maxLength={4}
                  value={formData.seconddriven1}
                  onChange={handleInputChange}
                  error={messageError.seconddriven1}
                />
              </div>
              <div className="col-lg-6 col-sm-4 p-1">
                {/* <Select
                label={"จังหวัด"}
                disabled={disableSave || loading}
                data={provincelist}
                value={formData.secondProvince}
                name={"secondProvince"}
                onChange={handleSelectChange}
                error={messageError.secondProvince}
                textProperty="ProvinceName"
                valueProperty="ProvinceID"
              /> */}
                <SelectOption
                  label={"จังหวัด"}
                  disabled={disableSave || loading}
                  data={pvl}
                  name={"secondProvince"}
                  onChange={(data) => {
                    handleSelectChange("secondProvince", data);
                  }}
                  value={pvl.find(
                    (item) => item.value === parseInt(formData.secondProvince)
                  )}
                  error={messageError.secondProvince}
                  isSearchable={true}
                />
              </div>
            </div>
          </div>

          <div className="card m-1 shadow ">
            <span className="fs-5 text-primary fw-bold ">
              {" "}
              <i className="bi bi-bag-check-fill me-1 "></i> ข้อมูลการลงสินค้า
            </span>
            <div className="row mx-2 mb-2">
              <div className="col-lg-6 col-sm-6 p-1">
                <span>วันที่ลงสินค้า </span>
                <div>
                  <DatePicker
                    className="datepicker-default form-control"
                    todayButton="Today"
                    dateFormat="dd/MM/yyyy"
                    selected={startDate}
                    disabled={disableSave || loading}
                    onChange={handleChangStartDate}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-6 p-1">
                <Select
                  label={"ระบุเวลา"}
                  data={timelist}
                  value={formData.time}
                  textProperty="Times"
                  disabled={disableSave || loading}
                  onChange={handleSelectChange}
                  error={messageError.time}
                  name={"time"}
                />
              </div>
              {!(formData.aimno === "04" || formData.aimno === "02") ? (
                <div className="col-lg-6 col-sm-6 p-1">
                  <Select
                    label={"สถานที่ลง"}
                    disabled={disableSave || loading}
                    data={storelist}
                    value={formData.storeno}
                    name={"storeno"}
                    onChange={handleSelectChange}
                    error={messageError.storeno}
                    textProperty="store_name"
                    valueProperty="Store_id"
                  />
                </div>
              ) : formData.aimno === "04" || formData.aimno === "02" ? (
                <div className="col-lg-6 col-sm-6 p-1">
                  <Select
                    label={"สถานที่ส่งสินค้า"}
                    disabled={disableSave || loading}
                    data={destinationlist}
                    value={formData.destination}
                    name={"destination"}
                    onChange={handleSelectChange}
                    error={messageError.destination}
                    textProperty="DES_Name"
                    valueProperty="DES_ID"
                  />
                </div>
              ) : null}
              {/* {formData.aimno === "04"  &&
      
          } */}

              {currentBranch && parseInt(currentBranch._id) !== 510 && (
                <div className="col-lg-6 col-sm-6 p-1">
                  <Select
                    label={"แหล่งที่มา"}
                    disabled={disableSave || loading}
                    data={soureproductlist}
                    value={formData.soureproduc}
                    name={"soureproduct"}
                    onChange={handleSelectChange}
                    error={messageError.soureproduct}
                  />
                </div>
              )}
              {statustail === true && (
                <div className="col-lg-6 col-sm-6 p-1">
                  <Select
                    label={"หาง Stock"}
                    disabled={disableSave || loading}
                    data={taillist}
                    value={formData.tailid}
                    name={"tailid"}
                    onChange={handleSelectChange}
                    error={messageError.tailid}
                  />
                </div>
              )}
              <div className="col-lg-6 col-sm-6 p-1">
                <Input
                  disabled={disableSave || loading}
                  label={"หมายเหตุ"}
                  name="remark"
                  maxLength={100}
                  value={formData.remark}
                  onChange={handleInputChange}
                  error={messageError.remark}
                />
              </div>
              <div className="form-check  ms-2">
                <InputCheck
                  name="disable"
                  className="form-check form-check-inline "
                  value={ckdisable}
                  label="ยกเลิกใช้งาน"
                  type="checkbox"
                  disable={disabled || disableSave || loading}
                  onChange={handleTextchange}
                  checked={ckdisable}
                  error=""
                />
                {/* <input
                className="form-check-input fs-5"
                type="checkbox"
                defaultValue
                id="flexCheckDefault"
              />
              <label
                className="form-check-label mt-1 fs-6"
                htmlFor="flexCheckDefault"
              >
                ยกเลิกการใข้งาน
              </label> */}
              </div>
            </div>
          </div>
        </div>
        <div className="row  my-2 mb-4">
          <div className="card col-lg-6 p-1 border-0">
            <button
              disabled={loading}
              type="button"
              className="btn btn-warning "
              data-bs-toggle="button"
              autoComplete="off"
              onClick={Gotobackup}
            >
              <FontAwesome name="arrow-left" className="me-2" />
              Back
            </button>
          </div>
          <div className="card col-lg-6 p-1 border-0">
            <button
              type="button"
              className="btn btn-primary "
              data-bs-toggle="button"
              autoComplete="off"
              disabled={disableSave || loading || onSave}
              onClick={() => handleonSave()}
            >
              <FontAwesome name="save" className="me-2" />
              SAVE
            </button>
          </div>
        </div>
      </div>
    );
  }
};

export default Registerhub;
